import {useReachGoalCallback} from '@yandex-delivery/blocks'
import {useFormContext} from '@yandex-delivery/form'

import type {Order} from 'src/shared/types'

import {appConfig} from '../config'

type ReachGoalParameters = {
  isBusiness?: boolean
  UID?: string
  tariff?: string
}

export function useFormUserEventHandler() {
  const {watch} = useFormContext<Order>()
  const reachGoalCallback = useReachGoalCallback<ReachGoalParameters>()

  const isBusiness = watch('isBusiness')
  const verticalName = watch('offerFlow.vertical.name')

  return function reachGoalHandler(goalName: OrderEventGoal) {
    reachGoalCallback(goalName, {
      isBusiness,
      tariff: verticalName,
      UID: appConfig.yandexuid,
    })
  }
}

export const enum OrderEventGoal {
  /**
   * Клик на активную кнопку "Заказать"
   */
  SubmitButtonClick = 'order2-button-click-request',
  /**
   * Клик на плашку Склад
   */
  B2BWarehouseVerticalClick = 'order2-button-click-warehouse',
  /**
   * Клик на опцию Расчетный счет в блоке Оплата
   */
  B2BOfferClick = 'order2-button-click-offer',
  /**
   * Клик на опцию XXL в блоке Отправление
   */
  B2BXXLSizeClick = 'order2-button-click-xxl-size',
  /**
   * Клик на опцию До двери в блоке Куда
   */
  B2BDeliveryTypeD2DClick = 'order2-button-click-d2d',
  /**
   * Клик на кнопку "Зарегистрироваться" в карточке Доставка от двери до двери
   */
  BannerD2DButtonClick = 'order2-button-click-reg-d2d',
  /**
   * Клик на кнопку "Зарегистрироваться" в карточке Доставка негабаритных вещей
   */
  BannerXXLSizeButtonClick = 'order2-button-click-reg-xxl',
  /**
   * Клик на кнопку "Зарегистрироваться" в карточке Оплата с РС
   */
  BannerRegistrationButtonClick = 'order2-button-click-reg-offer',
  /**
   * Событие успешного заказа перед тем как уйти в route
   */
  SuccessOrderCreate = 'order2-button-click-successful-request',
  /**
   * Клик на переключатель Бизнес
   */
  BusinessSwitchClick = 'order2-button-click-switcher',
  /**
   * Клик в компоненте выбора доставки По России или по Городу
   */
  VerticalDestinationClick = 'order2-button-click-choose-geo',
  /**
   * Клик по плашке вертикали
   */
  VerticalClick = 'order2-button-click-choose-tariff',
  /**
   * Выбор адреса (пункта выдачи) из suggest в блоке откуда
   */
  AddressFromSuggestResultItemClick = 'order2-suggest-click-from-address',
  /**
   * Клик на раздел адрес (пункт приема) в блоке откуда
   */
  AddressFromSuggestClick = 'order2-button-click-from-address',
  /**
   * Клик на раздел получатель в блоке откуда
   */
  AddressFromPhoneClick = 'order2-button-click-from-initiator',
  /**
   * Выбор адреса (пункта выдачи) из suggest в блоке куда
   */
  AddressToSuggestResultItemClick = 'order2-suggest-click-to-address',
  /**
   * Клик на раздел адрес (пункт выдачи) в блоке куда
   */
  AddressToSuggestClick = 'order2-button-click-to-address',
  /**
   * клик на раздел ПОЛУЧАТЕЛЬ в блоке КУДА
   */
  AddressToPhoneClick = 'order2-button-click-to-initiator',
  /**
   * Клик на раздел Оплата в блоке Оплата
   */
  SegmentClick = 'order2-suggest-click-to-segment',
  /**
   * Клик на Сейчас/Ко времени в блоке когда
   */
  WhenDueClick = 'order2-button-click-when-due',
  /**
   * Выбор любой из опций в блоке когда
   */
  OfferSelect = 'order2-button-click-when-tariff',
  /**
   * Переключение любой из опции
   */
  VerticalOptionsClick = 'order2-button-click-options',
  /**
   * Клик на кнопку "Изменить" в сроке карты в блоке Оплата
   */
  SelectPaymentCard = 'order2-button-click-pay-card',
  /**
   * Выбор размера посылки
   */
  ShipmenSizeClick = 'order2-button-click-shipment-size',
  PopupOpenSuperappClick = 'Order2-Pop-Go-Button-App',
  PopupStayOnSiteClick = 'Order2-Pop-Go-Button-Web',
  /**
   * Событие успешного заказа на тарифе грузовой межгород
   */
  SuccessOrderCargoIntercityCreate = 'cargo-intercity-button-click-successful-request',
}
